import { useParams } from "react-router-dom";
import { useGetTelehealthSessionInfo } from "../../../hooks";
import { useTrackEvent } from "../../../segment/segment";
import { useMemo } from "react";
import { EventTypeEnum } from "../../../segment/types";
import { useVideoPlatform } from "../../../hooks/useVideoPlatform";

export function useAdmissionTrackingEvents() {
  const { userViewed, userClicked } = useTrackEvent();
  const { patientShortId, providerShortId } = useParams<{
    patientShortId: string;
    providerShortId: string;
  }>();
  const { data } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const appointmentShortId = data?.telehealthSessionInfo?.appointment?.shortId;
  const [videoPlatform] = useVideoPlatform();

  return useMemo(() => {
    const payload = {
      patientShortId: patientShortId ?? "",
      providerShortId: providerShortId ?? "",
      appointmentShortId: appointmentShortId ?? "",
      source: videoPlatform ?? "",
    };
    return {
      trackAdmissionPromptViewed: () => {
        userViewed(EventTypeEnum.ADMISSION_PROMPT_VIEWED, payload);
      },
      trackJoinSessionClicked: () => {
        userClicked(EventTypeEnum.JOIN_SESSION_CLICKED, payload);
      },
      trackAdmissionPromptDismissed: () => {
        userClicked(EventTypeEnum.ADMISSION_PROMPT_DISMISSED, payload);
      },
    };
  }, [
    patientShortId,
    providerShortId,
    appointmentShortId,
    videoPlatform,
    userViewed,
    userClicked,
  ]);
}
